// extracted by mini-css-extract-plugin
module.exports = {"changelogMeta":"ChangelogEntry_changelogMeta__kcA1V","changelogDate":"ChangelogEntry_changelogDate__2gIE5","changelogBody":"ChangelogEntry_changelogBody__lqlZ5"};